import Vue from 'vue'

/**
 * @author Mariela Temozihui Tlahuel <mariela.temozihui@jbge.com.mx>
 *
 * Quotation to purchase order
 *
 * @param  {object}
 */

const toPurchaseOrden = (payload) =>
  Vue.$http.post(`purchase/quotation/to-purchase-order/`, payload)
    .then()
    .catch(err => {
      throw err
    })

export default toPurchaseOrden


// WEBPACK FOOTER //
// ./src/services/purchase/quotation/toPurchaseOrden.js